import logo from "../assets/images/logo.png"
import portfolio from "../assets/images/portfolio.png"
import reactAdminPanel from "../assets/images/ReactAdminPanel.png"
import html from "../assets/images/HTML5.png"
import css from "../assets/images/CSS3.png"
import js from "../assets/images/JavaScript.png"
import react from "../assets/images/React.png"
import php from "../assets/images/PHP.png"
import mysql from "../assets/images/MySQL.png"
import git from "../assets/images/Git.png"
import github from "../assets/images/github.png"
import bootstrap from "../assets/images/Bootstrap.png"
import firebase from "../assets/images/firebase.png"
import aboutImg from "../assets/images/About-card.png"
import idCard from "../assets/images/Id card.png"
import desiDelight from "../assets/images/Desidelight.png"
export const navbarLogo = {
    logo , href : "#home"
}
export const projects = {
    desiDelight , portfolio , reactAdminPanel
}
export const techStacks = {
    html , css , js , react , php , mysql , git , github , bootstrap , firebase
}
export const aboutCardImg = {
    aboutImg , idCard
}